import crud from "../../../../stores/crud";

const getDefaultState = () => {
	return {
		...crud.state,
		routes: {
			index: (parameters) => {
				return "service-providers/" + window.app.$router.currentRoute.params.serviceProvider + "/teams";
			},
			show: (parameters) => {
				return "service-providers/" + window.app.$router.currentRoute.params.serviceProvider + "/teams/:team";
			},
		},
	};
};

const state = getDefaultState();

export default {
	namespaced: true,
	state,
	actions: {
		...crud.actions,
	},
	mutations: {
		...crud.mutations,
	},
	getters: {
		...crud.getters,
	},
};
